module.exports = __webpack_public_path__ + "static/media/icon_arrow_light.7ae5ed22.svg";